import React from 'react';
import 'index.css';
import './Header.css';

export const Header = () => {
  return (
    <div className="survey-header">
      <h1>THE AFROBEAT<strong className="green"><a className="title-link" href="https://gilox.co/difference-between-afrobeats-and-afrobeat/" target="_blank" rel="noreferrer">S</a></strong> QUIZ</h1>
    </div>
  )
}